// extracted by mini-css-extract-plugin
export default {"overlay":"pw-z","bodyOpen":"qw-z","content":"rw-z","header":"sw-z","close":"tw-z","closeNoHeading":"uw-z"};